var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5003 23.8333V23H18.8337C18.3753 23 17.983 22.8368 17.6566 22.5104C17.3302 22.184 17.167 21.7917 17.167 21.3333V14.6667H15.5003V15.5C15.5003 15.9583 15.3371 16.3507 15.0107 16.6771C14.6844 17.0035 14.292 17.1667 13.8337 17.1667H11.3337C10.8753 17.1667 10.483 17.0035 10.1566 16.6771C9.83019 16.3507 9.66699 15.9583 9.66699 15.5V12.1667C9.66699 11.7083 9.83019 11.316 10.1566 10.9896C10.483 10.6632 10.8753 10.5 11.3337 10.5H13.8337C14.292 10.5 14.6844 10.6632 15.0107 10.9896C15.3371 11.316 15.5003 11.7083 15.5003 12.1667V13H20.5003V12.1667C20.5003 11.7083 20.6635 11.316 20.9899 10.9896C21.3163 10.6632 21.7087 10.5 22.167 10.5H24.667C25.1253 10.5 25.5177 10.6632 25.8441 10.9896C26.1705 11.316 26.3337 11.7083 26.3337 12.1667V15.5C26.3337 15.9583 26.1705 16.3507 25.8441 16.6771C25.5177 17.0035 25.1253 17.1667 24.667 17.1667H22.167C21.7087 17.1667 21.3163 17.0035 20.9899 16.6771C20.6635 16.3507 20.5003 15.9583 20.5003 15.5V14.6667H18.8337V21.3333H20.5003V20.5C20.5003 20.0417 20.6635 19.6493 20.9899 19.3229C21.3163 18.9965 21.7087 18.8333 22.167 18.8333H24.667C25.1253 18.8333 25.5177 18.9965 25.8441 19.3229C26.1705 19.6493 26.3337 20.0417 26.3337 20.5V23.8333C26.3337 24.2917 26.1705 24.684 25.8441 25.0104C25.5177 25.3368 25.1253 25.5 24.667 25.5H22.167C21.7087 25.5 21.3163 25.3368 20.9899 25.0104C20.6635 24.684 20.5003 24.2917 20.5003 23.8333ZM22.167 15.5H24.667V12.1667H22.167V15.5ZM22.167 23.8333H24.667V20.5H22.167V23.8333ZM11.3337 15.5H13.8337V12.1667H11.3337V15.5Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/departmentIcon.65ea1987ab117b7ffb1c61b0f69cbf16.svg";
export { ForwardRef as ReactComponent };